import axios from 'axios';
import moment from 'moment';
const baseUrl = `${process.env.REACT_APP_API_URL}/v1`;
const token = localStorage.getItem('token');

export const headersAuth = (formData) => ({
    headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': formData && 'multipart/form-data',
        responseType: 'blob'
    },
});
export const axiosGet = (url) => axios.get(`${baseUrl}${url}`, headersAuth());

export const axiosPost = (url, data, formdata) =>
    axios.post(
        `${baseUrl}${url}`, {
            data: {
                attributes: data,
            },
        },
        headersAuth(formdata),
    );

export const axiosPatch = (url, data) =>
    axios.patch(
        `${baseUrl}${url}`, {
            data: {
                attributes: data,
            },
        },
        headersAuth(),
    );

export const axiosPut = (url, data) =>
    axios.put(
        `${baseUrl}${url}`, {
            data: {
                attributes: data,
            },
        },
        headersAuth(),
    );

export const axiosDelete = (url) =>
    axios.delete(`${baseUrl}${url}`, headersAuth());